export const companies = {
  title: 'Công ty',
  resourceName: 'Công ty',
  titles: {
    list: 'Quản lý công ty',
    create: 'Thêm công ty',
    edit: 'Sửa công ty',
    detail: 'Chi tiết công ty',
    view: 'Chi tiết công ty',
    addQuick: 'Thêm nhanh',
  },
  sections: {
    basic: 'Thông tin cơ bản',
    note: 'Ghi chú',
    audit: 'Hệ thống',
  },
  fields: {
    code: 'Mã Cty',
    name: 'Tên Cty',
    country: 'Quốc gia',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    isActive: 'Trạng thái hoạt động',
    onOffAction: 'Bật / Tắt',
    note: 'Ghi chú',
    actions: 'Hành động',
  },
  countries: {
    VietNam: 'Việt Nam',
    TrungQuoc: 'Trung Quốc',
    HanQuoc: 'Hàn Quốc',
    NhatBan: 'Nhật Bản',
    Singapore: 'Singapore',
    ThaiLan: 'Thái Lan',
    DaiLoan: 'Đài Loan',
    HongKong: 'Hồng Kông',
    My: 'Mỹ',
    Duc: 'Đức',
    Anh: 'Anh',
  },
  status: {
    active: 'Hoạt động',
    inactive: 'Dừng hoạt động',
  },
  sortFields: {
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    tenCongTy: 'Tên công ty',
    maCongTy: 'Mã công ty',
    quocGia: 'Quốc gia',
  },
  filter: {
    search: 'Tìm kiếm',
    searchPlaceholder: 'Mã hoặc tên công ty',
    status: 'Trạng thái',
    statusAll: 'Tất cả',
    statusActive: 'Đang hoạt động',
    statusInactive: 'Ngừng hoạt động',
    sortField: 'Sắp xếp theo',
    sortDirection: 'Thứ tự',
    sortAsc: 'Tăng dần',
    sortDesc: 'Giảm dần',
  },
  validation: {
    codeNameRequired: 'Vui lòng nhập mã và tên công ty',
    codeDuplicated: 'Mã công ty đã tồn tại',
    codeFormat: 'Mã công ty chỉ gồm chữ, số, gạch ngang và gạch dưới',
  },
  messages: {
    noData: 'Không có dữ liệu công ty',
    totalCompanies: 'Tổng: {total} công ty',
    saving: 'Đang lưu...',
    savedSuccess: 'Đã lưu thành công',
    createSuccess: 'Tạo công ty thành công',
    updateSuccess: 'Cập nhật công ty thành công',
    deleteSuccess: 'Xóa công ty thành công',
    statusToggleSuccess: 'Đã chuyển trạng thái công ty',
    confirmDelete: 'Bạn có chắc chắn muốn xóa công ty này?',
    notFound: 'Không tìm thấy công ty',
    loadDetailError: 'Không tải được chi tiết công ty',
  },
}
